(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beastiary-product-navigation"]) return;
  try {
    
  (() => {
    const media = window.matchMedia('(max-width: 1023px)');
    const update = () => document.querySelectorAll('.bst-product-nav__disclosure').forEach(node => { node.open = !media.matches; });
    update();
    media.addEventListener('change', update);
    document.addEventListener('shopify:section:load', update);
  })();

  } catch(e) { console.error(e); }
})();
})();
